import { z } from 'zod';

/** DRF may serialise decimals as strings ("0.10") and ids as numbers or strings. */
export const looseNumber = z.coerce.number();
export const percent = z
  .union([z.number(), z.string(), z.null()])
  .optional()
  .transform((v) => (v == null || v === '' ? 0 : Number(v)))
  .pipe(z.number().min(0).max(1).catch(0));
export const optionalString = z
  .union([z.string(), z.number(), z.null()])
  .optional()
  .transform((v) => (v == null ? null : String(v)));
export const stringOr = (fallback = '') =>
  z
    .union([z.string(), z.number(), z.null()])
    .optional()
    .transform((v) => (v == null ? fallback : String(v)));
